module.exports = __webpack_public_path__ + "static/media/by.c9680b9b.svg";